<!-- Clio Classic Reporting view (#71, Phase 4). Reuses the MsxReportsComponent
     surface (Aurora-backed via clio-server /msx/* + /reporting/*) — reuse, not
     re-template. The embedded component owns the working report-type navigation;
     a single "coming soon" chip carries the deferred Undeliverable Emails report
     (per the defer decision) so we don't render a dead competing strip. B2 applies
     the Clio facelift to the `.classic-*` hooks + the embedded component's nav.
     Follow-up (#71): a fully V1-faithful report-type strip wired to /reporting/*. -->
<div class="classic-reporting">
    <div class="classic-report-types" role="note">
        <span class="classic-report-type coming-soon" aria-disabled="true" title="Coming soon">
            <span>Undeliverable Emails</span>
            <span class="classic-report-type-badge">coming soon</span>
        </span>
    </div>

    <!-- Reused MSX reports surface (its own report-type nav drives the content). -->
    <app-msx-reports></app-msx-reports>
</div>
